export default "assets/logo-84e70380.png";